var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info_tooltip",on:{"mouseenter":function($event){return _vm.setState(true)},"mouseleave":function($event){return _vm.setState(false)}}},[_c('div',{staticClass:"info_tooltip__content",class:{
			'info_tooltip__content--show': _vm.show,
			'info_tooltip__content--pointer_events': _vm.pointerEvents,
		}},[_vm._t("content")],2),_c('div',{staticClass:"info_tooltip__display",class:{
			'info_tooltip__display--hover': _vm.show
		}},[_vm._t("display")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }